import { Component } from '@angular/core';

@Component({
  selector: 'pf-background',
  standalone: true,
  templateUrl: './pf-background.component.html',
  styleUrl: './pf-background.component.scss',
})
export class PfBackgroundComponent {}
